export default __webpack_public_path__ + "static/media/keto_sleep@2x.6ec65bc6.jpg";